'use client';

import { useEffect } from 'react';
import * as Sentry from "@sentry/nextjs";

// Get DSN from environment variables
// In client-side code, only NEXT_PUBLIC_ prefixed vars are available
const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN || process.env.SENTRY_DSN;

/**
 * Client component to initialize Sentry for browser error tracking
 */
export function SentryInit() {
  useEffect(() => {
    // Only initialize once
    if (SENTRY_DSN && !Sentry.getClient()) {
      console.log("[Sentry Client] Initializing with DSN:", SENTRY_DSN ? "✓ Configured" : "✗ Not configured");
      
      Sentry.init({
        dsn: SENTRY_DSN,
        
        // Performance Monitoring
        tracesSampleRate: 0.1, // Capture 10% of transactions for performance monitoring
        
        // Tunnel to bypass ad blockers
        tunnel: "/api/glitchtip-tunnel",
        
        // Set the environment
        environment: process.env.NODE_ENV || "development",
      });
      
      console.log("[Sentry Client] Initialization complete");
    } else if (!SENTRY_DSN) {
      console.warn("[Sentry Client] Skipping initialization - no DSN configured. Set NEXT_PUBLIC_SENTRY_DSN environment variable.");
    }
  }, []);

  return null;
}
